import React from "react";
// import { immutableRecords } from "../../types";

/* eslint-disable react/prop-types */

// scrollPosition:
//   - viewport: PropTypeShapes.range,
//   - canvas: PropTypeShapes.range,
//   - zoom: PropTypes.number
// scrollActions:
//   Tell the ScrollableView to move:
//     - animateToViewport
//     - jumpToViewport
//     - animateRectIntoView
//     - jumpRectIntoView
//   Request live updates from ScrollableView:
//     - registerForLiveUpdates
//     - unregisterForLiveUpdates
//     where (un)registerForLiveUpdates receives an object containing (all optional):
//           - onLiveScrollStart
//           - onLiveScrollUpdate
//           - onLiveScrollStop

export const ScrollXPositionContext = React.createContext({
  xScrollPosition: null, //immutableRecords.ScrollPositionRecord(),
  xScrollActions: null
});

export const ScrollYPositionContext = React.createContext({
  yScrollPosition: null, //immutableRecords.ScrollPositionRecord(),
  yScrollActions: null
});

export const publishXScrollPosition = (children, value) => (
  <ScrollXPositionContext.Provider value={value} key="scrollXPositionContext">
    {children}
  </ScrollXPositionContext.Provider>
);

export const publishYScrollPosition = (children, value) => {
  return (
    <ScrollYPositionContext.Provider value={value} key="scrollYPositionContext">
      {children}
    </ScrollYPositionContext.Provider>
  );
};

export const withXScrollPositionContext = Component => {
  const ScrolledComponent = props => {
    const { forwardedRef, ...rest } = props;

    return (
      <ScrollXPositionContext.Consumer>
        {scrollXPositionContext => {
          return <Component ref={forwardedRef} {...rest} {...scrollXPositionContext} />;
        }}
      </ScrollXPositionContext.Consumer>
    );
  };

  return React.forwardRef((props, ref) => {
    return <ScrolledComponent {...props} forwardedRef={ref} />;
  });
};

export const withYScrollPositionContext = Component => {
  const ScrolledComponent = props => {
    const { forwardedRef, ...rest } = props;

    return (
      <ScrollYPositionContext.Consumer>
        {scrollYPositionContext => {
          return <Component ref={forwardedRef} {...rest} {...scrollYPositionContext} />;
        }}
      </ScrollYPositionContext.Consumer>
    );
  };

  return React.forwardRef((props, ref) => {
    return <ScrolledComponent {...props} forwardedRef={ref} />;
  });
};

// This function takes a component...
export const withScrollPositionContext = Component => withYScrollPositionContext(withXScrollPositionContext(Component));
